import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import config from '../../../utils/config';

const initialState = {
  checkoutType: null,
  checkoutDetails: null,
  salesTaxRate:{
    address:{},
    isLoadingToCalculateTax: false,
    isFailedToCalculateTax: false
  }
};

export const calculateTax = createAsyncThunk(
  'calculateTax',
  async ({ address, unitAmount, quantity, remittanceOrgId, token }) => {
    let response = await client.authorizeRequest({
      method: 'POST',
      url: `${config.serviceEndpoints.mpDpMetadataUrl}/salesTaxRate`,
      data: {
        address, unitAmount, quantity, remittanceOrgId:remittanceOrgId
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;

  }
);

export const paymentCheckout = createSlice({
  name: 'paymentCheckoutSlice',
  initialState,
  reducers: {
    saveCheckoutOption: (state, action) => {
      state.checkoutType = action.payload.checkoutType;
      state.rShare = action.payload.rShare
      state.checkoutDetails = action.payload.checkoutDetails;
      state.paymentSetting =action.payload.paymentSetting
    },
    resetSalesTax:(state,action)=>{
      state.salesTaxRate={
        address:{},
        isLoadingToCalculateTax: false,
        isFailedToCalculateTax: false
      }
    },
    resetCheckOutDetails:(state,action)=>{
      state.checkoutDetails=null;
      state.checkoutType=null;
    }
  },
  extraReducers: {
    [calculateTax.fulfilled]: (state, action) => {
      let address = action.meta.arg.address
      let {order_total_amount, rate,taxable_amount, amount_to_collect} =action.payload.data.tax

      state.salesTaxRate = {
        address,
        tax:{order_total_amount, rate,taxable_amount, amount_to_collect},
        isLoadingToCalculateTax: false,
        isFailedToCalculateTax: false
      }
    },
    [calculateTax.pending]: (state, action) => {
      state.salesTaxRate = {
        address: {},
        tax:null,
        isLoadingToCalculateTax: true,
        isFailedToCalculateTax: false
      }
    },
    [calculateTax.rejected]: (state, action) => {
      state.salesTaxRate = {
        address: {},
        tax:null,
        isLoadingToCalculateTax: false,
        isFailedToCalculateTax: true
      }
    }
  }
});

export const { saveCheckoutOption,resetSalesTax,resetCheckOutDetails } = paymentCheckout.actions;

export default paymentCheckout.reducer;